import { ActionContext } from 'vuex';

import { getLocalState } from '@/common/utils/store';

import { FTS_COMMON_ACTIONS_NAME, FTS_COMMON_MUTATIONS_NAME } from './name';
import { TFTSCommonState } from './types';

import links from '@/utils/links';
import request from '@/utils/request';

export async function searchCustomsProcedures(context: ActionContext<TFTSCommonState, unknown>) {
  return request(
    context,
    {
      url: links.ved.fts.common.getCustomsProcedures,
      name: getLocalState(FTS_COMMON_ACTIONS_NAME.searchCustomsProcedures),
      mutate: getLocalState(FTS_COMMON_MUTATIONS_NAME.setCustomsProcedures),
    },
    {},
  );
}

export async function searchProductsGroups(context: ActionContext<TFTSCommonState, unknown>) {
  return request(
    context,
    {
      url: links.ved.fts.common.getProductsGroups,
      name: getLocalState(FTS_COMMON_ACTIONS_NAME.searchProductsGroups),
      mutate: getLocalState(FTS_COMMON_MUTATIONS_NAME.setProductsGroups),
    },
    {},
  );
}

export async function searchProductsTwoSigns(context: ActionContext<TFTSCommonState, unknown>) {
  return searchProductsSigns(
    context,
    FTS_COMMON_ACTIONS_NAME.searchProductsTwoSigns,
    FTS_COMMON_MUTATIONS_NAME.setProductsTwoSigns,
    2,
  );
}

export async function searchProductsFourSigns(context: ActionContext<TFTSCommonState, unknown>) {
  return searchProductsSigns(
    context,
    FTS_COMMON_ACTIONS_NAME.searchProductsFourSigns,
    FTS_COMMON_MUTATIONS_NAME.setProductsFourSigns,
    4,
  );
}

export async function searchProductsSixSigns(context: ActionContext<TFTSCommonState, unknown>) {
  return searchProductsSigns(
    context,
    FTS_COMMON_ACTIONS_NAME.searchProductsSixSigns,
    FTS_COMMON_MUTATIONS_NAME.setProductsSixSigns,
    6,
  );
}

export async function searchProductsEightSigns(context: ActionContext<TFTSCommonState, unknown>) {
  return searchProductsSigns(
    context,
    FTS_COMMON_ACTIONS_NAME.searchProductsEightSigns,
    FTS_COMMON_MUTATIONS_NAME.setProductsEightSigns,
    8,
  );
}

export async function searchProductsNineSigns(context: ActionContext<TFTSCommonState, unknown>) {
  return searchProductsSigns(
    context,
    FTS_COMMON_ACTIONS_NAME.searchProductsNineSigns,
    FTS_COMMON_MUTATIONS_NAME.setProductsNineSigns,
    9,
  );
}

export async function searchProductsTenSigns(context: ActionContext<TFTSCommonState, unknown>) {
  return searchProductsSigns(
    context,
    FTS_COMMON_ACTIONS_NAME.searchProductsTenSigns,
    FTS_COMMON_MUTATIONS_NAME.setProductsTenSigns,
    10,
  );
}

async function searchProductsSigns(
  context: ActionContext<TFTSCommonState, unknown>,
  name: string,
  mutate: string,
  len: number,
) {
  return request(
    context,
    {
      url: links.ved.fts.common.getProductsSigns,
      name: getLocalState(name),
      mutate: getLocalState(mutate),
    },
    {
      len: len,
    },
  );
}

export async function searchOkatoTree(context: ActionContext<TFTSCommonState, unknown>) {
  return request(
    context,
    {
      url: links.ved.fts.common.getOkatoTree,
      name: getLocalState(FTS_COMMON_ACTIONS_NAME.searchOkatoTree),
      mutate: getLocalState(FTS_COMMON_MUTATIONS_NAME.setOkatoTree),
    },
    {},
  );
}

export async function searchCountriesTree(context: ActionContext<TFTSCommonState, unknown>) {
  return request(
    context,
    {
      url: links.ved.fts.common.getCountriesTree,
      name: getLocalState(FTS_COMMON_ACTIONS_NAME.searchCountriesTree),
      mutate: getLocalState(FTS_COMMON_MUTATIONS_NAME.setCountriesTree),
    },
    {},
  );
}
